import useSubmissionViewData from './useSubmissionViewData';

export default useSubmissionViewData;
